
<div *ngIf="templateName" class="template-wrap hidden-print hidden-xs ft-template-name text-ellipsis  mat-title" tooltip-placement="bottom" tooltip="{{templateName}}" title="{{templateName}}">
    {{templateName}}
</div>

